import React from "react";
import { connect } from "react-redux";
import { Row, Col } from "reactstrap";
import ElementWrapper from "../../../components/element/ElementWrapper/ElementWrapper";
import { Droppable } from "react-beautiful-dnd";
import { elementConstants } from "../../../../constants/cms/form/element/element.constants";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import "../../../style/ContentStyles.css";
import FindInPageOutlinedIcon from "@material-ui/icons/FindInPageOutlined";
import ElementDropItem from "../../../components/editor/ElementDropItem/ElementDropItem";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import MoneyOffIcon from "@material-ui/icons/MoneyOff";
import GroupAddIcon from "@material-ui/icons/GroupAdd";
import CloudUploadIcon from '@material-ui/icons/CloudUpload';

class UserPageElements extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      collapse: false,
      elements: null,
    };
  }
  toggle() {
    this.setState((state) => ({ collapse: !state.collapse }));
  }
  render() {
    return (
      <div className="element-list-aside">
        <div style={{ margin: " 0px 2px" }}>
          <div
            style={{
              color: "#222",
              fontWeight: "600",
              fontSize: "10px",
              color: "rgb(81, 97, 103)",
              textTransform: "uppercase",
              borderBottom: "0px !important",
              wordBreak: "break-all",
              paddingBottom: "8px",
            }}
          >
            <SystemLabel name="FormElements" />
          </div>
        </div>
        <Droppable isDropDisabled={true} droppableId={"sidebar-preconfirmation"}>
          {(provided) => (
            <div ref={provided.innerRef}>
              <Row style={{ margin: "0px", width: "225px" }}>
                <Col style={{ padding: "0px", paddingBottom: "5px" }}>
                  <ElementWrapper id={`${elementConstants.PRE_CONFIRMATION}`} index={0}>
                    <ElementDropItem
                      name={"PreConfirmation"}
                      draggableId={`${elementConstants.PRE_CONFIRMATION}`}
                      icon={
                        <FindInPageOutlinedIcon
                          style={{
                            fontSize: "40px",
                            padding: "5px 0px",
                          }}
                        />
                      }
                    />
                  </ElementWrapper>
                </Col>
                <Col style={{ padding: "0px", paddingBottom: "5px" }}>
                  <ElementWrapper id={`${elementConstants.PROFILEIMAGE_UPLOAD}`} index={0}>
                    <ElementDropItem
                      name={"ProfileImageUploader"}
                      draggableId={`${elementConstants.PROFILEIMAGE_UPLOAD}`}
                      icon={
                        <AccountCircleIcon
                          style={{
                            fontSize: "40px",
                            padding: "5px 0px",
                          }}
                        />
                      }
                    />
                  </ElementWrapper>
                </Col>
                <Col style={{ padding: "0px", paddingBottom: "5px" }}>
                  <ElementWrapper id={`${elementConstants.DISCOUNT}`} index={0}>
                    <ElementDropItem
                      name={"RebateField"}
                      draggableId={`${elementConstants.DISCOUNT}`}
                      icon={
                        <MoneyOffIcon
                          style={{
                            fontSize: "40px",
                            padding: "5px 0px",
                          }}
                        />
                      }
                    />
                  </ElementWrapper>
                </Col>
                <Col style={{ padding: "0px", paddingBottom: "5px" }}>
                  <ElementWrapper id={`${elementConstants.GROUP_REGISTRATION}`} index={0}>
                    <ElementDropItem
                      name={"GroupRegistration"}
                      draggableId={`${elementConstants.GROUP_REGISTRATION}`}
                      icon={
                        <GroupAddIcon
                          style={{
                            fontSize: "40px",
                            padding: "5px 0px",
                          }}
                        />
                      }
                    />
                  </ElementWrapper>
                </Col>
                <Col style={{ padding: "0px", paddingBottom: "5px" }}>
                  <ElementWrapper id={`${elementConstants.FILE_UPLOADER}`} index={0}>
                    <ElementDropItem
                      name={"FileUploader"}
                      draggableId={`${elementConstants.FILE_UPLOADER}`}
                      icon={
                        <CloudUploadIcon
                          style={{
                            fontSize: "40px",
                            padding: "5px 0px",
                          }}
                        />
                      }
                    />
                  </ElementWrapper>
                </Col>
              </Row>
            </div>
          )}
        </Droppable>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    alert: state.alert,
    cElements: state.element,
    template: state.template,
    page: state.page,
    form: state.form,
  };
}

export default connect(mapStateToProps)(UserPageElements);
